export const FEATURES_CONSTANTS = {
  title: "Features of Onemind’s IaaS",
  list: [
    {
      label: "On-Demand Resource Allocation",
      text: "Scale resources instantly based on real-time needs.",
    },
    {
      label: "Comprehensive Networking Services",
      text: "Secure data flow with VPNs, load balancers, and firewalls.",
    },
    {
      label: "AI-Driven Security & Compliance",
      text: "Encryption, real-time monitoring, and compliance-ready cloud.",
    },
    {
      label: "Cost-Effective Pricing",
      text: "Pay only for resources used, reducing IT overhead.",
    },
    {
      label: "Global Accessibility",
      text: "Access infrastructure from anywhere in the world with 99.99% uptime.",
    },
    {
      label: "Full Hybrid & Multi-Cloud Compatibility",
      text: "Integrate with on-premises systems.",
    },
  ],
};
